
import * as Comlink from 'comlink';

import Worker from './TorCollection.worker.js';

const tc_worker = Comlink.wrap(new Worker());

class TornadoCollection {
    constructor(key) {
        this.key = key;
    }

    async getNTornadoes(subintvs, partitioner, with_time_unknown) {
        const packSubInterval = intv => {
            try {
                return intv.toRepr();
            }
            catch {
                return 'Interval|' + intv.toISO();
            }
        }

        const subintv_strs = subintvs.map(packSubInterval);
        const partitioner_str = partitioner === undefined ? undefined : partitioner.toRepr();

        return await tc_worker.getNTornadoes(this.key, subintv_strs, partitioner_str, with_time_unknown);
    }

    async getGeoJSON(interval, partitioner) {
        const interval_str = interval.toRepr();
        const partitioner_str = partitioner === undefined ? undefined : partitioner.toRepr();

        return await tc_worker.getGeoJSON(this.key, interval_str, partitioner_str);
    }

    async getGeoJSONById(id) {
        return await tc_worker.getGeoJSONById(this.key, id);
    }

    async getPropertyValues(property, interval, partitioner) {
        const interval_str = interval.toRepr();
        const partitioner_str = partitioner === undefined ? undefined : partitioner.toRepr();

        return await tc_worker.getPropertyValues(this.key, property, interval_str, partitioner_str);
    }

    async applyFilters(filters) {
        const filter_strs = Object.values(filters).map(filt => filt.toRepr());
        const key = await tc_worker.applyFilters(this.key, filter_strs);

        return new TornadoCollection(key);
    }

    static async fromServer(url) {
        const key = await tc_worker.downloadFile(url);
        return new TornadoCollection(key);
    }

    deleteInstance() {
        tc_worker.deleteInstance(this.key);
    }
}

export default TornadoCollection;
